// middleware/auth.global.ts
export default defineNuxtRouteMiddleware(async (to) => {
    const { loggedIn, fetch } = useUserSession()

    // Redirect logged-in users trying to access the login page
    if (to.path === '/login' && loggedIn.value) {
        return navigateTo('/')
    }

    // Allow access to login or logout routes
    if (['/login', '/logout'].includes(to.path)) {
        return
    }

    if (!loggedIn.value) {
        console.log('User not logged in, redirecting to login...')
        return navigateTo('/login')
    }

    try {
        // Validate session with backend
        await fetch()
        console.log('Session validated successfully.')
    }
    catch (error) {
        console.error('Session validation failed:', error)
        return navigateTo('/login')
    }
})
